/* eslint-disable import/prefer-default-export */
export const pluralize = (count: number | string, word: string): string | number => {
  const number = typeof count === 'string' ? parseInt(count, 10) : count;
  return number === 1 ? word : `${word}s`;
};

export const camelcaseKeys = (obj: unknown): unknown => {
  const toCamelCase = (str: string): string => str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());

  if (Array.isArray(obj)) {
    return obj.map((item) => camelcaseKeys(item));
  }

  if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      const camelCaseKey = toCamelCase(key);
      (acc as Record<string, unknown>)[camelCaseKey] = camelcaseKeys((obj as Record<string, unknown>)[key]);
      return acc;
    }, {} as Record<string, unknown>);
  }

  return obj;
};

export const snakecaseKeys = (obj: unknown): unknown => {
  const toSnakeCase = (str: string): string => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

  if (Array.isArray(obj)) {
    return obj.map((item) => snakecaseKeys(item));
  }

  if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      const snakeCaseKey = toSnakeCase(key);
      (acc as Record<string, unknown>)[snakeCaseKey] = snakecaseKeys((obj as Record<string, unknown>)[key]);
      return acc;
    }, {} as Record<string, unknown>);
  }

  return obj;
};
